import React from "react";
import { FormGroup, Label, Input, Container } from "reactstrap";
import { useField, useFormikContext, ErrorMessage } from "formik";

// App
import { Options, RadioGroupProps } from "../../../../types";

const RadioGroup: React.FC<RadioGroupProps> = ({
    name,
    options,
    label,
    isRequired,
    onChange,
    columns = 1,
    labelStyle,
    labelClassName,
}) => {
    const { handleChange } = useFormikContext();
    const [field, meta] = useField(name);

    return (
        <FormGroup tag="fieldset" className="mb-3">
            {label && (
                <Label style={{ ...labelStyle }} className={labelClassName}>
                    {label}
                    {isRequired && " *"}
                </Label>
            )}
            <div className="ms-3" style={{ display: "grid", gridTemplateColumns: `repeat(${columns}, 1fr)`, }}>
                {options.map((option: Options) => (
                    <div key={option.value}>
                        <FormGroup check key={option.value}>
                            <Label check>
                                <Input
                                    type="radio"
                                    {...field}
                                    value={option.value}
                                    id={`${name}-${option.value}`}
                                    name={name}
                                    checked={field.value === option.value}
                                    onChange={(e) => {
                                        if (onChange) {
                                            onChange(e);
                                        }
                                        handleChange(field.name)(option.value);
                                    }}
                                />
                                {option.label}
                            </Label>
                        </FormGroup>
                        {field.value === option.value && option.children && (
                            <Container>{option.children}</Container>
                        )}
                    </div>
                ))}
            </div>

            {meta?.touched && meta?.error && (
                <ErrorMessage
                    render={(msg) => (
                        <div className="invalid-feedback" style={{ display: "block" }}>
                            {msg}
                        </div>
                    )}
                    name={name}
                />
            )}
        </FormGroup>
    );
};

export default RadioGroup;
